import { i18n as I18n } from '../utils/i18n';

// Functions rather than constants throughout this file: every field is a
// translation, and at module scope they would resolve before i18next is
// initialised, freezing the raw keys in for the lifetime of the process.
export const getBasics = () => [
  {
    question: I18n.t('faq.topics.basics.questions.first'),
    answer: I18n.t('faq.topics.basics.answers.first'),
  },
  {
    question: I18n.t('faq.topics.basics.questions.second'),
    introText: I18n.t('faq.topics.basics.answers.second.intro_text'),
    endText: I18n.t('faq.topics.basics.answers.second.end_text'),
    formattedText: true,
    listItems: [],
    roomTypes: {
      clinical: [
        I18n.t('room_types_landing_page.minor_operations.title'),
        I18n.t('room_types_landing_page.treatment.title'),
        I18n.t('room_types_landing_page.examination.title'),
        I18n.t('room_types_landing_page.consulting.title'),
      ],
      nonClinical: [
        I18n.t('room_types_landing_page.counselling.title'),
        I18n.t('room_types_landing_page.group.title'),
        I18n.t('room_types_landing_page.meeting.title'),
        I18n.t('room_types_landing_page.office.title'),
      ],
    },
  },
  {
    question: I18n.t('faq.topics.basics.questions.third'),
    answer: I18n.t('faq.topics.basics.answers.third'),
  },
  {
    question: I18n.t('faq.topics.basics.questions.fourth'),
    answer: I18n.t('faq.topics.basics.answers.fourth'),
  },
  {
    question: I18n.t('faq.topics.basics.questions.fifth'),
    answer: I18n.t('faq.topics.basics.answers.fifth'),
  },
  {
    question: I18n.t('faq.topics.basics.questions.sixth'),
    answer: I18n.t('faq.topics.basics.answers.sixth'),
  },
];

export const getGettingStarted = () => [
  {
    question: I18n.t('faq.topics.getting_started.questions.first'),
    answer: I18n.t('faq.topics.getting_started.answers.first'),
  },
  {
    question: I18n.t('faq.topics.getting_started.questions.second'),
    introText: I18n.t('faq.topics.getting_started.answers.second.intro_text'),
    listItems: [
      I18n.t('faq.topics.getting_started.answers.second.list_item_first'),
      I18n.t('faq.topics.getting_started.answers.second.list_item_second'),
    ],
    formattedText: true,
  },
  {
    question: I18n.t('faq.topics.getting_started.questions.third'),
    answer: I18n.t('faq.topics.getting_started.answers.third'),
  },
];

export const getSetupPayments = () => [
  {
    question: I18n.t('faq.topics.setup_payments.questions.first'),
    answer: I18n.t('faq.topics.setup_payments.answers.first'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.second'),
    answer: I18n.t('faq.topics.setup_payments.answers.second'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.third'),
    answer: I18n.t('faq.topics.setup_payments.answers.third'),
    introText: I18n.t('faq.topics.setup_payments.answers.third.intro_text'),
    listItems: [
      I18n.t('faq.topics.setup_payments.answers.third.list_item_first'),
      I18n.t('faq.topics.setup_payments.answers.third.list_item_second'),
    ],
    endText: I18n.t('faq.topics.setup_payments.answers.third.end_text'),
    formattedText: true,
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.fourth'),
    answer: I18n.t('faq.topics.setup_payments.answers.fourth'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.fifth'),
    answer: I18n.t('faq.topics.setup_payments.answers.fifth'),
    introText: I18n.t('faq.topics.setup_payments.answers.fifth.intro_text'),
    listItems: [
      I18n.t('faq.topics.setup_payments.answers.fifth.list_item_first'),
      I18n.t('faq.topics.setup_payments.answers.fifth.list_item_second'),
    ],
    formattedText: true,
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.sixth'),
    answer: I18n.t('faq.topics.setup_payments.answers.sixth'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.seventh'),
    answer: I18n.t('faq.topics.setup_payments.answers.seventh'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.eighth'),
    answer: I18n.t('faq.topics.setup_payments.answers.eighth'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.ninth'),
    answer: I18n.t('faq.topics.setup_payments.answers.ninth'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.tenth'),
    answer: I18n.t('faq.topics.setup_payments.answers.tenth'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.eleventh'),
    answer: I18n.t('faq.topics.setup_payments.answers.eleventh'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.twelfth'),
    answer: I18n.t('faq.topics.setup_payments.answers.twelfth'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.thirteenth'),
    answer: I18n.t('faq.topics.setup_payments.answers.thirteenth'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.fourteenth'),
    answer: I18n.t('faq.topics.setup_payments.answers.fourteenth'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.fifteenth'),
    answer: I18n.t('faq.topics.setup_payments.answers.fifteenth'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.sixteenth'),
    answer: I18n.t('faq.topics.setup_payments.answers.sixteenth'),
  },
  {
    question: I18n.t('faq.topics.setup_payments.questions.seventeenth'),
    answer: I18n.t('faq.topics.setup_payments.answers.seventeenth'),
  },
];

export const getBookingsCancellations = () => [
  {
    question: I18n.t('faq.topics.bookings_cancellations.questions.first'),
    answer: I18n.t('faq.topics.bookings_cancellations.answers.first'),
  },
  {
    question: I18n.t('faq.topics.bookings_cancellations.questions.second'),
    answer: I18n.t('faq.topics.bookings_cancellations.answers.second'),
  },
  {
    question: I18n.t('faq.topics.bookings_cancellations.questions.third'),
    answer: I18n.t('faq.topics.bookings_cancellations.answers.third'),
  },
  {
    question: I18n.t('faq.topics.bookings_cancellations.questions.fourth'),
    answer: I18n.t('faq.topics.bookings_cancellations.answers.fourth'),
  },
  {
    question: I18n.t('faq.topics.bookings_cancellations.questions.fifth'),
    answer: I18n.t('faq.topics.bookings_cancellations.answers.fifth'),
  },
  {
    question: I18n.t('faq.topics.bookings_cancellations.questions.sixth'),
    answer: I18n.t('faq.topics.bookings_cancellations.answers.sixth'),
  },
  {
    question: I18n.t('faq.topics.bookings_cancellations.questions.seventh'),
    listItems: [
      I18n.t(
        'faq.topics.bookings_cancellations.answers.seventh.list_item_first'
      ),
      I18n.t(
        'faq.topics.bookings_cancellations.answers.seventh.list_item_second'
      ),
      I18n.t(
        'faq.topics.bookings_cancellations.answers.seventh.list_item_third'
      ),
      I18n.t(
        'faq.topics.bookings_cancellations.answers.seventh.list_item_fourth'
      ),
    ],
    formattedText: true,
  },
  {
    question: I18n.t('faq.topics.bookings_cancellations.questions.eighth'),
    answer: I18n.t('faq.topics.bookings_cancellations.answers.eighth'),
  },
];

export const getUsingRoomOnSite = () => [
  {
    question: I18n.t('faq.topics.using_room_on_site.questions.first'),
    answer: I18n.t('faq.topics.using_room_on_site.answers.first'),
  },
  {
    question: I18n.t('faq.topics.using_room_on_site.questions.second'),
    answer: I18n.t('faq.topics.using_room_on_site.answers.second'),
  },
  {
    question: I18n.t('faq.topics.using_room_on_site.questions.third'),
    answer: I18n.t('faq.topics.using_room_on_site.answers.third'),
  },
  {
    question: I18n.t('faq.topics.using_room_on_site.questions.fourth'),
    answer: I18n.t('faq.topics.using_room_on_site.answers.fourth'),
  },
  {
    question: I18n.t('faq.topics.using_room_on_site.questions.fifth'),
    answer: I18n.t('faq.topics.using_room_on_site.answers.fifth'),
  },
];
